import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  let authToken = localStorage.getItem('token');
  req = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${authToken}`)
  });
  return next(req)
};
